export default {"src":"/frontend-static/_next/static/media/shipping.3b369783.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};